pushToArray